// AuthTokenManager: wrapper over API TokenManager with user helpers
import { TokenManager as ApiTokenManager, TokenRefreshManager } from '../api/interceptors';

const USER_INFO_KEY = 'arbiwin_user_info';

export const AuthTokenManager = {
  getAccessToken() {
    return ApiTokenManager.getAccessToken();
  },
  getRefreshToken() {
    return ApiTokenManager.getRefreshToken();
  },
  getTokenExpiry() {
    return ApiTokenManager.getTokenExpiry();
  },
  isTokenExpired() {
    return ApiTokenManager.isTokenExpired();
  },
  setTokens(accessToken, refreshToken, expiresIn) {
    return ApiTokenManager.setTokens(accessToken, refreshToken, expiresIn);
  },
  clearTokens() {
    return ApiTokenManager.clearTokens();
  },
  async refreshToken() {
    return TokenRefreshManager.refreshToken();
  },
  setUserInfo(user) {
    try {
      localStorage.setItem(USER_INFO_KEY, JSON.stringify(user || null));
    } catch (e) {
      // ignore
    }
  },
  getUserInfo() {
    try {
      const raw = localStorage.getItem(USER_INFO_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
};

export default AuthTokenManager;


